export enum MFAType {
  EMAIL = 'EMAIL',
  SMS = 'SMS',
}
